import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[70vh] text-center px-4">
      <p className="font-heading text-7xl md:text-9xl font-black text-background-300 select-none">
        404
      </p>
      <h1 className="mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-950">
        页面走丢了
      </h1>
      <p className="mt-2 text-sm text-foreground-500">您访问的页面不存在：{location.pathname}</p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="px-5 py-2.5 rounded-md bg-primary-500 text-background-950 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors"
        >
          返回首页
        </Link>
        <Link
          to="/search"
          className="px-5 py-2.5 rounded-md bg-background-200/70 text-foreground-900 text-sm font-semibold whitespace-nowrap hover:bg-background-300/70 transition-colors"
        >
          去搜索视频
        </Link>
      </div>
    </div>
  );
}